import { render, staticRenderFns } from "./dropImageUploader.vue?vue&type=template&id=5cf10c6c&scoped=true"
import script from "./dropImageUploader.vue?vue&type=script&lang=js"
export * from "./dropImageUploader.vue?vue&type=script&lang=js"
import style0 from "./dropImageUploader.vue?vue&type=style&index=0&id=5cf10c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf10c6c",
  null
  
)

export default component.exports